module.exports = __webpack_public_path__ + "media/images/bg-footer-253d2fb6ff1cbebe557e337a2248a0b2.png";